import { executeRequest, Request, Response } from '@jfs/network'
import { getAPIURL, getPaymentHeader } from '../config'

/**
 * New PG
 * @param merchantID
 */
const responseParser = (response: Response) => {
  const { data } = response
  return data
}

export const offerTxnApply = (input: any) => {
  const request: Request<{}> = {
    apiPath: `${getAPIURL('offerTxnApply')}`,
    method: 'POST',
    headers: getPaymentHeader(),
    body: { ...input },
  }
  return executeRequest(request)
    .then((response: any) => {
      return responseParser(response)
    })
    .catch((err) => {
      const {
        data: { error },
      } = err
      throw error
    })
}
